var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeChatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#7BB32E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 13.5C16.029 13.5 12 16.8585 12 21C12 23.388 13.347 25.506 15.4365 26.877L14.25 29.25L17.4825 27.8655C18.1755 28.1115 18.8955 28.314 19.665 28.4085C19.56 27.951 19.5 27.4815 19.5 27C19.5 22.8645 23.5365 19.5 28.5 19.5C28.9545 19.5 29.3985 19.5375 29.8365 19.5915C29.0445 16.1235 25.392 13.5 21 13.5ZM18 19.125C17.379 19.125 16.875 18.621 16.875 18C16.875 17.379 17.379 16.875 18 16.875C18.621 16.875 19.125 17.379 19.125 18C19.125 18.621 18.621 19.125 18 19.125ZM24 19.125C23.379 19.125 22.875 18.621 22.875 18C22.875 17.379 23.379 16.875 24 16.875C24.621 16.875 25.125 17.379 25.125 18C25.125 18.621 24.621 19.125 24 19.125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 27C36 23.6865 32.6415 21 28.5 21C24.3585 21 21 23.6865 21 27C21 30.3135 24.3585 33 28.5 33C29.181 33 29.829 32.904 30.4575 32.7675L34.5 34.5L33.102 31.7055C34.854 30.6075 36 28.9185 36 27ZM26.25 26.625C25.629 26.625 25.125 26.121 25.125 25.5C25.125 24.879 25.629 24.375 26.25 24.375C26.871 24.375 27.375 24.879 27.375 25.5C27.375 26.121 26.871 26.625 26.25 26.625ZM30.75 26.625C30.129 26.625 29.625 26.121 29.625 25.5C29.625 24.879 30.129 24.375 30.75 24.375C31.371 24.375 31.875 24.879 31.875 25.5C31.875 26.121 31.371 26.625 30.75 26.625Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeChatIcon);
export default __webpack_public_path__ + "static/media/WeChatIcon.6b5be78b.svg";
export { ForwardRef as ReactComponent };